import manifest from '../data/imageManifest.json'

export const imageInfo = (src) => manifest[src] || null

export const srcSetFor = (src, format) => {
  const info = imageInfo(src)
  if (!info || !info.formats.includes(format)) return null
  return info.widths.map((w) => `${info.base}-${w}.${format} ${w}w`).join(', ')
}

/** Smallest generated variant at least `width` wide, or the original src. */
export const optimizedUrl = (src, width = 1100, format = 'webp') => {
  const info = imageInfo(src)
  if (!info || !info.formats.includes(format)) return src
  const w = info.widths.find((v) => v >= width) ?? info.widths[info.widths.length - 1]
  return `${info.base}-${w}.${format}`
}
